var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        title: !_vm.isEdit ? "商品分类黑名单" : "配置商品分类黑名单规则",
        visible: _vm.visible,
        size: !_vm.isEdit ? "25%" : "75%",
        "append-to-body": true,
        wrapperClosable: true,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "blacklist-drawer-content" }, [
        _c("div", { staticClass: "main-body" }, [
          _vm.isEdit
            ? _c("div", { staticClass: "left-panel" }, [
                _c("div", { staticClass: "toolbar" }, [
                  _c(
                    "div",
                    { staticClass: "toolbar-left" },
                    [
                      _c("el-input", {
                        staticClass: "search-input",
                        attrs: {
                          placeholder: "搜索商品分类...",
                          clearable: "",
                          "prefix-icon": "el-icon-search",
                        },
                        model: {
                          value: _vm.filterText,
                          callback: function ($$v) {
                            _vm.filterText =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "filterText",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "toolbar-actions" },
                    [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "如果数据多，可能需要一些时间",
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: { click: _vm.toggleExpandAll },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.isAllExpanded ? "折叠全部" : "展开全部"
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: { click: _vm.resetCheck },
                        },
                        [_vm._v("重置勾选")]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "tree-header" }, [
                  _c("span", { staticClass: "header-label" }, [
                    _vm._v("商品分类名称"),
                  ]),
                  _c("span", { staticClass: "header-id" }, [_vm._v("分类ID")]),
                  _c("span", { staticClass: "header-count" }, [
                    _vm._v("子分类数"),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "tree-wrapper" },
                  [
                    _c("el-tree", {
                      ref: "tree",
                      attrs: {
                        data: _vm.treeData,
                        props: _vm.treeProps,
                        "filter-node-method": _vm.filterNode,
                        "default-checked-keys": _vm.checkedKeys,
                        "default-expanded-keys": _vm.expandedKeys,
                        "node-key": "id",
                        "show-checkbox": "",
                        "highlight-current": "",
                      },
                      on: {
                        check: _vm.handleCheck,
                        "node-expand": _vm.handleNodeExpand,
                        "node-collapse": _vm.handleNodeCollapse,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var node = ref.node
                              var data = ref.data
                              return _c("span", { staticClass: "tree-node" }, [
                                _c("span", { staticClass: "node-label" }, [
                                  _vm._v(_vm._s(node.label)),
                                ]),
                                _c("span", { staticClass: "node-id" }, [
                                  _vm._v(_vm._s(data.id)),
                                ]),
                                _c("span", { staticClass: "node-count" }, [
                                  _c("span", { staticClass: "count-badge" }, [
                                    _vm._v(
                                      _vm._s(
                                        data.children ? data.children.length : 0
                                      )
                                    ),
                                  ]),
                                ]),
                              ])
                            },
                          },
                        ],
                        null,
                        false,
                        2452180495
                      ),
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "right-panel" }, [
            _c("div", { staticClass: "stats-section stat-card--blue" }, [
              _c("div", { staticClass: "section-title" }, [
                _vm._v("当前黑名单范围统计"),
              ]),
              _c("div", { staticClass: "stats-cards" }, [
                _c("div", { staticClass: "stat-card" }, [
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.checkedLeafCount)),
                  ]),
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v("已屏蔽子分类"),
                  ]),
                ]),
                _c("div", { staticClass: "stat-card" }, [
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.checkedTopLevelCount)),
                  ]),
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v("覆盖一级分类"),
                  ]),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "checked-paths-section" },
              [
                _c("div", { staticClass: "path-list-header" }, [
                  _vm._v("已勾选路径列表"),
                ]),
                _c(
                  "div",
                  { staticClass: "path-list" },
                  _vm._l(_vm.pagedCheckedPaths, function (row, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "path-item",
                        attrs: { title: row.fullPath },
                      },
                      [_vm._v(" " + _vm._s(row.fullPath) + " ")]
                    )
                  }),
                  0
                ),
                _vm.checkedPaths.length > 0
                  ? _c("el-pagination", {
                      staticClass: "path-pagination",
                      attrs: {
                        small: "",
                        background: "",
                        layout: "total, prev, pager, next, jumper",
                        total: _vm.checkedPaths.length,
                        "page-size": _vm.pathPageSize,
                        "page-sizes": [10, 20, 50, 100],
                        "current-page": _vm.pathCurrentPage,
                      },
                      on: {
                        "current-change": _vm.handlePathPageChange,
                        "size-change": _vm.handlePathSizeChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm.isEdit
              ? _c(
                  "div",
                  { staticClass: "footer-bar" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "medium",
                          loading: _vm.saveLoading,
                        },
                        on: { click: _vm.handleSave },
                      },
                      [_vm._v(" 确认并保存规则 ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }